import { DataTableDirective } from "../../node_modules/angular-datatables";
import { Subject } from "../../node_modules/rxjs";
import { Directive, ContentChild, ElementRef, OnDestroy, OnInit } from "../../node_modules/@angular/core";

@Directive({ selector: 'content-tab' })
export class TableDirective implements OnDestroy, OnInit {


    dtElement: DataTableDirective;
    dtTrigger: Subject<any>;
    dtOptions: DataTables.Settings;

    @ContentChild(DataTableDirective)
    content: DataTableDirective;
    public getDtElement() {
        return this.content;
    }

    constructor(private el: ElementRef) {
        this.dtTrigger = new Subject();
        this.dtOptions = {};
    }

    ngOnInit(): void {
    }
    ngOnDestroy(): void {
    }

    refreshTable() {
        if (this.getDtElement().dtInstance) {
            this.getDtElement().dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.destroy();
                if (this.dtTrigger.observers) {
                    this.dtTrigger.next();
                }
            });
        }
        else {
            if (this.dtTrigger.observers) {
                this.dtTrigger.next();
            }
        }
    }

    destroyTable() {
        this.dtTrigger.unsubscribe();

        this.getDtElement().dtInstance.then((dtInstance: DataTables.Api) => {

            dtInstance.destroy();
        });
    }

    filterBySearchText(searchString: string) {
        this.getDtElement().dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.search(searchString).draw();
        });
    }
}


// WEBPACK FOOTER //
// ./src/directives/table-directive.ts